import React from 'react';

export default function () {
  return (
    <div className='placeholder-announcement-card'>
      <div className='slider' />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/ui/Placeholders/CardAnnouncement.jsx